import { render } from "./date_value.vue?vue&type=template&id=3f521050&lang=pug"
import script from "./date_value.vue?vue&type=script&lang=js"
export * from "./date_value.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__